import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import Swal from 'sweetalert2';
import {constants} from '../../constant/constant';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnInit {
  checkin: any;
  checkout: any;
  package: any;
  bookForm: any;
  country = constants.country;
  constructor(private formBuilder: FormBuilder,private userService:UserService, private datePipe: DatePipe,
              private route :Router,private scrollToService: ScrollToService,) {
    this.package = JSON.parse(localStorage.getItem('package'));

    this.bookForm = this.formBuilder.group({
      days: ['',Validators.required],
      name: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      pax: ['', Validators.required],
      children: ['', Validators.required],
      infants: ['', Validators.required],
      adults: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      cont: ['', Validators.required],
      package: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.bookForm.controls['start'].setValue(this.package.packageStartDate);
    this.bookForm.controls['end'].setValue(this.package.packageEndDate);
    this.bookForm.controls['package'].setValue(this.package.packageName);
    this.bookForm.controls['days'].setValue(this.package.noOfDays +' Days');
    this.triggerScrollTo();
  }

  saveBooking(){
    let  req={
      customerDTO:{
        clientEmail: this.bookForm.controls.email.value,
        clientName:this.bookForm.controls.name.value,
        country: this.bookForm.controls.cont.value,
        mobileNumber: this.bookForm.controls.mobile.value,
      },
      adults:this.bookForm.controls.adults.value,
      children:this.bookForm.controls.children.value,
      infants:this.bookForm.controls.infants.value,
      end:this.datePipe.transform(this.bookForm.controls.end.value, 'y-MM-dd'),
      packageId: this.package.id,
      isTailorMade:0,
      start: this.datePipe.transform(this.bookForm.controls.start.value, 'y-MM-dd'),
    }
    this.userService.bookingSave(req).subscribe(
        res => {
          if (res.responseCode == 200) {
            Swal.fire(
                'Booking Success!',
                'session booked successfully',
                'success'
            )
            this.route.navigate(['/index-packages']);
          } else {
            Swal.fire(
                'Booking Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }

}
